import type { FC } from 'react';

import { useWineryTagManager } from '@xing-com/crate-companies-shared';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { Outlet } from '@xing-com/crate-xinglet';
import { useFeatureSwitch } from '@xing-com/hub';

import { MainLayout } from './components/layouts/main-layout';
import { LoggedInPage } from './components/logged-in-page/logged-in-page';
import { CompaniesDataProvider } from './contexts/companies-data-context';

export const App: FC = () => {
  const { isLoggedIn } = useLoginState();
  useWineryTagManager();

  const showNewLoggedInOverview = useFeatureSwitch(
    'enable_new_logged_in_companies_overview'
  );

  const AppComponent =
    isLoggedIn && !showNewLoggedInOverview ? LoggedInPage : MainLayout;

  return (
    <CompaniesDataProvider>
      <AppComponent>
        <Outlet />
      </AppComponent>
    </CompaniesDataProvider>
  );
};
